@if (constructView; as construct) {
  <div class="border border-[#74808B] rounded-[8px] w-full py-6 px-8">
    <div class="flex flex-col gap-8">
      <h3><b>Exam Title: </b> {{construct.exam_title}}</h3>
      <div>
        <h3 class="font-semibold">Type</h3>
        <p class="text-gray-500">Placement Exam</p>
      </div>
      <div>
        <h3 class="font-semibold">Assigned Course</h3>
        <p class="text-gray-500">
          @if (courses.length > 0) {
            {{ retrieveCourseName(construct.course_id) }}
          } @else {
            Loading...
          }
        </p>
      </div>
      <div>
        <h3 class="font-semibold">Attempts</h3>
        <p class="text-gray-500">Only <b>{{construct.attemptsMax}}</b> attempt is allowed</p>
      </div>
      <div>
        <h3 class="font-semibold">Parts</h3>
        @if (parts.length > 0) {
          <div class="flex flex-col">
            @for (part of parts.controls; track part; let index = $index) {
              <mat-expansion-panel [togglePosition]="'before'" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <p class="font-medium">{{index+1}}. {{part.get('part_name')?.value}}</p>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="text-sm"><b>Duration: </b>{{convertMinutes(part.get('part_duration_minutes')?.value)}}</p>
                <!-- TODO add total question count later -->
                <p class="text-sm"><b>Description: </b>
                  @if (checkForHTMLTags(part.get('part_instructions')?.value)) {
                    <span [innerHTML]="part.get('part_instructions')?.value"></span>
                  }
                  @if (!checkForHTMLTags(part.get('part_instructions')?.value)) {
                    <span [innerText]="part.get('part_instructions')?.value"></span>
                  }
                </p>
              </mat-expansion-panel>
            }
          </div>
        } @else {
          <p class="text-gray-500">No parts created yet</p>
        }
      </div>
      @if (assignView; as assign) {
        <div class="flex flex-col gap-8">
          <div>
            <b>TimeFrame</b>
            @if (assign.timeframes.length > 0 && subsections.length > 0) {
              <div>
                <table class="text-sm text-left table-auto rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 mt-3">
                  <thead class="border-b border-gray-300">
                    <tr>
                      <th class="px-4 py-2">Subsection</th>
                      <th class="px-4 py-2">First Start</th>
                      <th class="px-4 py-2">Last Start</th>
                      <th class="px-4 py-2">Finish By</th>
                    </tr>
                  </thead>
                  @for (timeframe of assign.timeframes; track timeframe; let i = $index) {
                    <tbody>
                      <tr>
                        <td class="px-4 py-2">{{ retrieveSubsectionName(timeframe.subsection_id) }}</td>
                        <td class="px-4 py-2">
                          <p>{{timeframe.first_start | date:"MMM dd, yyyy 'at' hh:mm a" }}</p>
                        </td>
                        <td class="px-4 py-2">
                          <p>{{timeframe.last_start | date:"MMM dd, yyyy 'at' hh:mm a" }}</p>
                        </td>
                        <td class="px-4 py-2">
                          <p>{{timeframe.finish_by | date:"MMM dd, yyyy 'at' hh:mm a" }}</p>
                        </td>
                      </tr>
                    </tbody>
                  }
                </table>
              </div>
            } @else {
              <p class="text-gray-500">No subsections assigned yet</p>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
